module.exports = __webpack_public_path__ + "img/visa-light.34843e74.svg";